import { Card, styled } from '@mui/material';

export const ServerCard = styled(Card)(({ theme }) => ({
  borderRadius: '12px',
  borderColor: theme.palette.divider,
  backgroundColor: theme.palette.background.paper,
  backgroundImage: 'none',
}));
